import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const MessagesDetailFill = (props: SvgIconT.Props) => (
  <SvgIcon width={13} height={13} {...props} viewBox="0 0 13 13">
    <>
      <defs>
        <path
          d="M1799.5,151.985 L1804.75919,154.977688 L1804.93603,155.063475 C1805.29783,155.210539 1805.70337,155.210539 1806.06517,155.063475 L1806.24202,154.977688 L1811.4988,151.9865 L1811.5,158 C1811.5,158.828427 1810.82849,159.5 1810.00015,159.5 L1801.00105,159.5 C1800.17271,159.5 1799.5012,158.828427 1799.5012,158 L1799.5,151.985 Z M1810.00015,147.5 C1810.82849,147.5 1811.5,148.171573 1811.5,149 L1811.4988,150.2615 L1805.5006,153.673773 L1799.5,150.26 L1799.5012,149 C1799.5012,148.171573 1800.17271,147.5 1801.00105,147.5 L1810.00015,147.5 Z"
          id="path-1"
        ></path>
        <filter x="0.0%" y="0.0%" width="100.0%" height="100.0%" filterUnits="objectBoundingBox" id="filter-2">
          <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetInner1"></feOffset>
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
            result="shadowInnerInner1"
          ></feComposite>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
            type="matrix"
            in="shadowInnerInner1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g stroke="none" strokeWidth="1" fillRule="evenodd">
        <g transform="translate(-1799.000000, -147.000000)">
          <use fillRule="evenodd" xlinkHref="#path-1"></use>
          <use fill="black" fillOpacity="1" filter="url(#filter-2)" xlinkHref="#path-1"></use>
        </g>
      </g>
    </>
  </SvgIcon>
);

export default MessagesDetailFill;
